//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'
import { get } from 'lodash';


//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.userBooksList;
//  -- Examples array selector --------

export const useUserBookList = () => {
    const selectedData = useSelector(selectore, shallowEqual)
    return get(selectedData,"books",[]);
}

export const useUserBook = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}